// extracted by mini-css-extract-plugin
export default {"container":"V2Yf_z4eYKv8GHELjgQ7","text":"QKq0dWB_3l0sSqQB2cma"};